// extracted by mini-css-extract-plugin
export var downArrow = "_ad-0";
export var label = "_ad-1";
export var treatmentCard = "_ad-3";
export var upArrow = "_ad-2";